import React from "react";
import FastTextInput from "components/FormElements/FastTextInput";
import { HTML_DATE_TIME_FORMAT, fromString } from "helpers/Date";

function DatetimeMetaProperty(props) {
    return <FastTextInput name={props.name} as="input" type="datetime-local" />;
}

export const BeforeSave = (val) => {
    return fromString(val).toUTC().toFormat("yyyy-MM-dd HH:mm:ss");
};

export const BeforeMount = (val) => {
    return fromString(val).toLocal().toFormat(HTML_DATE_TIME_FORMAT);
};

export default DatetimeMetaProperty;

export const Property = DatetimeMetaProperty;

export const Label = "Date and Time";
